import UserService from "@/services/UserService";
angular.module("leanlaw.core").factory("iocContainer", ["$http", "$rootScope", "$state", "$stateParams", "leanLawApi", "leanLawAuth", "global", "currentAccountId", "ModalService", "alerts", "clientMatterManager", "singleRequest", "invoiceFilterService", "accountingService", "matterFilterService", "snippetService", "codeService", "chargeManager", "entryEditService", "tracking", "onboardService", "billingFilterService", "entriesManager", "matterTagsService", "timerManager", function ($http, $rootScope, $state, $stateParams, leanLawApi, leanLawAuth, global, currentAccountId, ModalService, alerts, clientMatterManager, singleRequest, invoiceFilterService, accountingService, matterFilterService, snippetService, codeService, chargeManager, entryEditService, tracking, onboardService, billingFilterService, entriesManager, matterTagsService, timerManager) {
  const userService = new UserService(leanLawApi, leanLawAuth, global, currentAccountId);
  const state = $state;
  const stateParams = $stateParams;
  const rootScope = $rootScope;
  const http = $http;
  return {
    http,
    userService,
    leanLawApi,
    modalService: ModalService,
    alerts,
    state,
    stateParams,
    clientMatterManager,
    rootScope,
    leanLawAuth,
    singleRequest,
    invoiceFilterService,
    accountingService,
    matterFilterService,
    snippetService,
    codeService,
    chargeManager,
    entryEditService,
    tracking,
    onboardService,
    billingFilterService,
    entriesManager,
    matterTagsService,
    timerManager
  };
}]);